import React from 'react';
import { Button } from 'theme-ui';
import ChevronDownIcon from '~/assets/images/icons/chevron-down.svg';

type Props = {
  showCode: boolean;
  toggleShowCode: () => void;
  label: string;
};

const ToggleButton = ({ showCode, toggleShowCode, label }: Props) => {
  return (
    <Button
      onClick={toggleShowCode}
      variant="bare"
      sx={{
        fontSize: '1.1rem',
        textTransform: 'uppercase',
        fontWeight: 'medium',
        height: 'fit-content',
        minHeight: 0,
        lineHeight: 1,
        position: 'relative',
        svg: {
          transition: 'transform 0.2s ease-in-out',
          transform: showCode ? 'rotate(180deg)' : 'rotate(0deg)',
          position: 'absolute',
          right: '-2.4rem',
        },
        path: {
          stroke: 'white',
        },
      }}
    >
      {label}
      <ChevronDownIcon />
    </Button>
  );
};

export default ToggleButton;
